import React, { FC, useEffect, useRef, useState } from 'react';

import clsx from 'clsx';

import { City } from '@domains/common-data';

import { useClickOutside } from '@hooks/click-outside';

import { StyledInput } from '@components/common/StyledInput/StyledInput';
import { ArrowDownIcon } from '@components/icons/ArrowDownIcon';

import styles from './AddressCityPicker.module.scss';

export type AddressCityPickerCityPickerProps = {
    items: City[];
    selectedItem: City;
    onChange?(value: City): void;
    className?: string;
};
export const AddressCityPicker: FC<AddressCityPickerCityPickerProps> = (props) => {
    const { items, selectedItem, onChange, className } = props;

    const [selected, setSelected] = useState<City>(selectedItem);
    const [isShowList, setIsShowList] = useState(false);

    const ref = useRef<HTMLDivElement>(null);

    useClickOutside({
        ref: ref,
        action: () => setIsShowList(false),
    });

    useEffect(() => {
        setSelected(selectedItem);
    }, [selectedItem]);

    return (
        <div className={clsx(styles.root, className)} ref={ref}>
            <StyledInput
                value={selected.name}
                label="Выберите город"
                onFocus={() => setIsShowList(true)}
                actionIcon={ArrowDownIcon}
                classes={{ actionIcon: styles.icon }}
                readOnly
            />
            {isShowList && (
                <div className={styles.list}>
                    {items.map((item, index) => (
                        <button
                            type="button"
                            className={clsx(
                                styles.option,
                                item.id === selected.id && styles.isSelected,
                            )}
                            key={index}
                            onClick={() => {
                                if (onChange !== undefined) onChange(item);
                                setSelected(item);
                                setIsShowList(false);
                            }}
                        >
                            {item.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
